import {
    selectDoc,
    event,
    toggleClass,
    hasClass,
    isVisible,
    ajax,
    selectArr,
    removeClass,
    addClass
} from "../utils/utils";

import {inputEmail, inputEmpty, inputPassword, validDate} from "../helpers/service.validator";
import {hideMobileNav, hideNavComponents, toggleCheckOutSide} from "./component.nav";

const props = {
    pageContainer: selectDoc('#PageContainer'),

    navCta: selectDoc('#cta-account'),
    navIcon: selectDoc('#cta-account .account'),

    wsAccount: selectDoc('#ws-account'),
    closeMain: selectDoc('#ws-account #close-account'),

    loginContainer: selectDoc('#ws-account #login-menu'),
    loginSubmit: selectDoc('#login-menu #login-submit'),
    openLogin: selectDoc('#ws-account #open-login'),
    emailLogin: selectDoc('#CustomerEmail'),
    passwordLogin: selectDoc('#CustomerPassword'),
    errorsLogin: selectDoc('#login-menu .errors ul'),

    createContainer: selectDoc('#ws-account #create-account'),
    openCreate: selectDoc('#ws-account #open-create'),
    closeCreate: selectDoc('#ws-account #close-account-create'),
    submitCreate: selectDoc('#ws-account #submit-create'),
    nameCreate: selectDoc('#RegisterForm-FirstName'),
    lastNameCreate: selectDoc('#RegisterForm-LastName'),
    emailCreate: selectDoc('#RegisterForm-email'),
    passwordCreate: selectDoc('#RegisterForm-password'),
    birthdayCreate: selectDoc('#RegisterForm-birthday'),
    anniversaryCreate: selectDoc('#RegisterForm-anniversary'),
    errorsCreate: selectDoc('#create-account .errors ul'),

    triangle: selectDoc('#triangle'),

    gValue: '',
    authKey: '',
    responseContainer: selectDoc('#ws-account .response-container'),
}

const redirectLoggedIn = (errors, redirect) => {
    let url = window.location.href;
    if (url.indexOf('?') > -1) {
        url += '&' + redirect + '=true'
    } else {
        url += '?' + redirect + '=true'
    }

    if (errors) {
        errors.map(error => {
            url += '&error=' + error.innerHTML
        })
    }

    window.location.href = url;
}

const ajaxMiniAccountCall = (button, inputs = [], requestData = {}, endpoint = '', captchaContainer, errorsContainer, redirect) => {
    button.disabled = true;
    let error = false;

    inputs.map(input => {
        if (input) {
            let inputMsg = selectDoc('.' + input.id + '.error-input')

            /**
             * Clean error
             */
            input.classList.remove('error')
            inputMsg.classList.remove('show')
            inputMsg.innerText = ''

            /**
             * Validate empty
             */
            if(!input.id.includes('birthday') && !input.id.includes('anniversary')) {
                if (inputEmpty(input.value)) {
                    error = true;
                    input.classList.add('error')

                    inputMsg.innerText = "Field can't be empty."
                    inputMsg.classList.add('show')
                    $(input).focus();
                } else {
                    /**
                     * Validate email
                     */
                    if (input.id.includes('Email') || input.id.includes('email')) {
                        if (!inputEmail(input.value)) {
                            error = true;
                            input.classList.add('error')

                            inputMsg.innerText = "Please enter a valid email address."
                            inputMsg.classList.add('show')
                        }
                    }

                    /**
                     * Validate password
                     */
                    if (input.id.includes('password') || input.id.includes('Password')) {
                        if (!inputPassword(input.value)) {
                            error = true;
                            input.classList.add('error')

                            inputMsg.innerText = "Please enter a valid password."
                            inputMsg.classList.add('show')
                        }
                    }
                }
            }

            if(input.id.includes('birthday') || input.id.includes('anniversary')) {
                if (!validDate(input.value) && !inputEmpty(input.value)) {
                    error = true;
                    input.classList.add('error')

                    inputMsg.innerText = "Invalid date format, please use: mm/dd/yyyy"
                    inputMsg.classList.add('show')
                }
            }

        }
    });

    if (!error) {
        /**
         * Check if captcha params required
         */
        if (props.authKey && props.gValue) {
            requestData = {
                "authenticity_token": props.authKey,
                "g-recaptcha-response": props.gValue,
            }
        }

        /**
         * Prepare request data
         */
        let formBody = []
        for (var property in requestData) {
            if (requestData[property] != '') {
                var encodedKey = encodeURIComponent(property);
                var encodedValue = encodeURIComponent(requestData[property]);
                formBody.push(encodedKey + "=" + encodedValue);
            }
        }

        /**
         * Make call
         */
        ajax('POST',
            endpoint,
            formBody.join('&'),
            'application/x-www-form-urlencoded'
        ).then(function (response) {
            button.disabled = false;
            response = JSON.parse(response).response;

            /**
             * If Captcha present on HTML response
             */
            if (response.includes('shopify-challenge__container')) {

                /**
                 * Render response
                 */
                props.responseContainer.innerHTML = response;

                /**
                 * Extract auth keys
                 */
                props.authKey = (selectDoc("input[name='authenticity_token']").value);

                let siteKey = '';
                selectArr("script").map(script => {
                    if (script.innerHTML.includes('recaptchaCallback')) {
                        script.innerHTML.split(':').map(portion => {
                            if (portion.includes('size')) {
                                siteKey = portion.split(',')[0]
                            }
                        })
                    }
                })

                /**
                 * Clean response
                 */
                props.responseContainer.innerHTML = ''

                /**
                 * Render captcha
                 */
                let scriptTag = document.createElement('script'),
                    scriptTagTwo = document.createElement('script');

                scriptTagTwo.innerHTML = `
                        var onCaptchaSuccessCustom = function () {
                            var event;
                            try {
                                event = new Event('captchaSuccessCustom', {bubbles: true, cancelable: true});
                            } catch (e) {
                                event = document.createEvent('Event');
                                event.initEvent('captchaSuccessCustom', true, true);
                            }
                            window.dispatchEvent(event);
                        }

                        var recaptchaCallbackCustom = function () {
                            let widgetId = grecaptcha.render('${captchaContainer}', {
                                sitekey: ${siteKey},
                                size: (window.innerWidth > 320) ? 'normal' : 'compact',
                                callback: 'onCaptchaSuccessCustom',
                            })
                        ;};
                        `
                props.responseContainer.appendChild(scriptTagTwo)

                scriptTag.src = 'https://www.recaptcha.net/recaptcha/api.js?onload=recaptchaCallbackCustom&amp;render=explicit&amp;hl=en';
                props.responseContainer.appendChild(scriptTag)

                /**
                 * Listen response
                 */
                window.addEventListener('captchaSuccessCustom', function () {
                    let responseInput = document.querySelector('.g-recaptcha-response');
                    props.gValue = responseInput.value
                }, false);

            } else {
                props.gValue = '';
                props.authKey = '';

                props.responseContainer.innerHTML = response;
                let errors = selectArr(errorsContainer)
                props.responseContainer.innerHTML = '';

                if (errors.length > 0) {
                    redirectLoggedIn(errors, redirect)
                } else {
                    redirectLoggedIn(null, redirect)
                }
            }
        });
    } else {
        button.disabled = false;
    }
}

export const toggleMiniAccount = (closeMenus = true) => {
    toggleClass(props.wsAccount, 'show')
    toggleClass(props.navIcon, 'active')
    $('.one-click-social-login-buttons').attr('title', 'Social Login')

    if (hasClass(props.wsAccount, 'show')) {
        //Hide other components
        hideNavComponents(true,true,false);

        //Show
        toggleCheckOutSide();
        toggleCheckOutSide(props.wsAccount, props.navIcon);
        addClass(document.body, 'child-open');
        addClass(document.body, 'no-scroll');
    } else {
        //Hide
        toggleCheckOutSide();
        closeMenus ? removeClass(document.body, 'child-open') : '';
        removeClass(document.body, 'no-scroll');
    }
}

const initNav = async () => {
    /**
     * Main account menu
     */
    event(props.navCta, 'click', toggleMiniAccount)
    event(props.closeMain, 'click', toggleMiniAccount)
    if (props.openLogin) {
        event(props.openLogin, 'click', function () {
            toggleClass(props.loginContainer, 'hide')
            toggleClass(props.createContainer, 'show')
        })
    }

    /**
     * Create account menu
     */
    if (props.openCreate) {
        event(props.openCreate, 'click', function () {
            toggleClass(props.loginContainer, 'hide')
            toggleClass(props.createContainer, 'show')
        })
        event(props.closeCreate, 'click', toggleMiniAccount)
    }
}

const initLoginFlow = async () => {
    if (props.loginSubmit) {
        event(props.loginSubmit, 'click', function (e) {
            e.preventDefault();
            props.loginSubmit.disabled = true
            ajaxMiniAccountCall(
                props.loginSubmit,
                [props.emailLogin, props.passwordLogin],
                {
                    "checkout_url": '/account/login',
                    "customer[email]": props.emailLogin.value,
                    "customer[password]": props.passwordLogin.value,
                    "form_type": 'customer_login',
                    "utf8": '✓'
                },
                "/account/login",
                'g-recaptcha-login',
                '#login-errors .errors ul li',
                'log-in')
        })
    }
}

const initRegisterFlow = async () => {
    if (props.submitCreate) {
        event(props.submitCreate, 'click', function (e) {
            e.preventDefault();
            ajaxMiniAccountCall(
                props.submitCreate,
                [
                    props.nameCreate,
                    props.lastNameCreate,
                    props.emailCreate,
                    props.passwordCreate,
                    //props.birthdayCreate,
                    //props.anniversaryCreate,
                ],
                {
                    "customer[first_name]": props.nameCreate.value,
                    "customer[last_name]": props.lastNameCreate.value,
                    "customer[email]": props.emailCreate.value,
                    "customer[password]": props.passwordCreate.value,
                    //"customer[note][Birthday]": props.birthdayCreate.value,
                    //"customer[note][Anniversary]": props.anniversaryCreate.value,
                    "form_type": 'create_customer',
                    "utf8": '✓'
                },
                "/account",
                'g-recaptcha-create',
                '#create-errors .errors ul li',
                'create')
        })
    }
};

const initializer = () => {
    checkUrl();
    initNav();
    initRegisterFlow();
    initLoginFlow();
}

const checkUrl = async () => {
    let params = new URL(document.URL).searchParams,
        errors = params.getAll('error');

    if (params.get('log-in') || params.get('create')) {

        if (params.get('create') && errors.length < 1) {
            window.location.href = '/account?tab=account';
            return;
        }

        if (errors.length > 0) {
            if (params.get('create')) {
                errors.map(error => {
                    props.errorsCreate.innerHTML += '<li>' + error + '</li>'
                })
                toggleClass(props.loginContainer, 'hide')
                toggleClass(props.createContainer, 'show')
            } else {
                errors.map(error => {
                    props.errorsLogin.innerHTML += '<li>' + error + '</li>'
                })
            }
        }

        //Show popup
        setTimeout(function () {
            toggleClass(props.navIcon, 'active')
            toggleClass(props.wsAccount, 'show')
            toggleCheckOutSide(props.wsAccount, props.navIcon)
        }, 2000);

        //Clear url
        let baseUrl = window.location.href.split("?")[0];
        window.history.pushState('name', document.title, baseUrl);
    }
}

export const MiniAccount = {
    init:                   () => initializer(),
    toggleMiniAccount:  () => toggleMiniAccount()
}
